import React from "react";
import {
  useTable,
  useExpanded,
} from "react-table";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";

const headerProps = (props, { column }) => {
  return getStyles(props, "center", column.style);
};

const cellProps = (props, { cell }) =>
  getStyles(props, cell.column.align, cell.column.style);

const getStyles = (props, align = "left", style = {}) => [
  props,
  {
    style: {
      justifyContent: align === "right" ? "flex-end" : align === "left" ? "flex-start" : "center",
      alignItems: "flex-start",
      display: "flex",
      ...style,
    },
  },
];

/**
 * As in the previous versions, any react table needs colums where at the core we have a field Header, and accessor
 * As in the previous versions, a react table has data that consist of an array of JSONs
 */
const ReactTable = ({
  columns,
  data,
  renderRowSubComponent,
  isExpandable,
  ColumnFilter,
  GlobalFilter,
  allowColumnFilter,
  allowGlobalFilter,
  filterTypes,
  renderBody,
  allowInfiniteScroll,

  footer,
  className,
  headerBackgroundColor,
  exp,
  ...props
}) => {
  // functions to run when a column is filtered depending on the type
  const defaultColumn = {
    // Let's set up our default Filter UI
    Filter: ColumnFilter,
    minWidth: 10,
    maxWidth: 400,
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    visibleColumns,
    state: { globalFilter },
    toggleAllRowsExpanded,
    toggleRowExpanded
    
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      filterTypes,
      autoResetExpanded: false,
      
    },
    // hooks for filters

    // hooks for exander,
    useExpanded
  );


  React.useEffect(() => {
    
    // data.forEach((element,i) => {
    //   toggleRowExpanded(""+i, element.salary_proportion?true:false)
    // });
  } ,[data]);


  return (

    <div className="table-responsive">
      <Table bordered hover responsive="md" size='md' {...getTableProps()}>
        <thead className={` ${headerBackgroundColor}`}>

          {headerGroups.map(headerGroup => (

            <tr {...headerGroup.getHeaderGroupProps()}>
              {/* <th className='text-center'>#</th> */}
              {headerGroup.headers.map(column => {


                const classNames = column.className ?? ""
                  .replace("text-left", "")
                  .replace("text-right", "");

                return (

                  <th className={`text-center ${classNames}`} {...column.getHeaderProps()}>
                    {column.render('Header')}
                  </th>
                )
              }
              )}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}

        >
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              <React.Fragment key={`rf_${i}`}>
              <tr {...{ ...row.getRowProps() }} >
                {/* <td>{ pagination? (Number(pageSize*pageIndex)+i+1) : i + 1}</td> */}
                {row.cells.map(cell => {
                  return (
                    <td {...{ ...cell.getCellProps(), className: `${cell.column.className ? cell.column.className : ""}` }}>
                      {cell.render('Cell') ?? "-"}
                    </td>
                  )
                })}
              </tr>
              {row.isExpanded ? (
                <tr className="expanded">
                  <td className="align-middle"></td>
                  <td colSpan={visibleColumns.length-2}>
                  
                    {renderRowSubComponent({ row, data })}
                  </td>
                  <td className="align-middle text-center">{row.original.salary_sum}</td>
                </tr>
              ) : null}
              </React.Fragment>
            )
          })}
        </tbody>
        {
                            footer ? (<tfoot>
                                {footerGroups.map(group => (
                                    <tr {...group.getFooterGroupProps()}>
                                        {/* <td></td> */}
                                        {group.headers.map(column => (
                                            <td {...column.getFooterProps()} className="text-end fw-bold">{column.render('Footer')}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tfoot>) : null
                        }

      </Table>
      {rows.length > 0 ? "" : (<div className="alert bg-warning  p-0 text-center">
        No Records
      </div>
      )}
    </div>

  );
};

ReactTable.propTypes = {
  // Same as the previous versions
  columns: PropTypes.array.isRequired,
  // Same as the previous versions
  data: PropTypes.array.isRequired,
  // Function that renders a subcomponent,
  // in this case it is receiving a json containing a row, feel free to modify it
  renderRowSubComponent: PropTypes.func,
  // function to render the body. receives rows, prepareRowFunction, isExpandable, and renderRowSubComponent
  renderBody: PropTypes.func,
  // Indicates if the table row has a subcomponent. By default false
  // if it is true, renderRowSubComponent should be defined
  isExpandable: PropTypes.bool,
  // Filter For a single Column: this is a function that returns a jsx(prerably an input)
  ColumnFilter: PropTypes.func,
  // Filter for all data : this is a function that returns a jsx(prerably an input)
  GlobalFilter: PropTypes.func,
  allowColumnFilter: PropTypes.bool,
  allowGlobalFilter: PropTypes.bool,
  // array of filters
  filterTypes: PropTypes.objectOf(PropTypes.func),
  // changes the table head and body classnames
  allowInfiniteScroll: PropTypes.bool,

  footer: PropTypes.bool,
  className: PropTypes.string,
};

ReactTable.defaultProps = {
  isExpandable: false,
  allowColumnFilter: false,
  allowGlobalFilter: true,
  allowInfiniteScroll: false,
  footer: false,
  className: "",
 
};

export default ReactTable;
